"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63923],{

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 20826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ affiliateNavigationEvents; },
/* harmony export */   "d": function() { return /* binding */ affiliateActions; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

// Affiliate Partner - Navigate
var affiliateNavigationEvents = {
    /**
     Navigate - 1
     When user landed at external community page
  */ externalCommunityViewed: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("External Community Viewed");
    },
    /**
     Navigate - 2
     when user landed on detail Confirmed Code Community pop-up
  */ confirmedCodeCommunityViewed: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Confirmed Code Community Viewed", {
            affiliate_code: code
        });
    },
    /**
     Navigate - 3
     when user landed on Success Activated Code Community page
  */ activatedSuccessCodeCommunityViewed: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Success Activated Code Community Viewed", {
            affiliate_code: code
        });
    },
    /**
     Navigate - 4 & 5
     when user (member of community) landed on External Community Page
  */ membersExternalCommunityViewed: function(isExitEnabled) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Members External Community Viewed", {
            is_exit: isExitEnabled ? "True" : "False"
        });
    },
    /**
     Navigate - 6
     when user landed on Exit External Community pop-up
  */ exitExternalCommunityViewed: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Exit External Community Viewed");
    }
};
// Affiliate Partner - Action
var affiliateActions = {
    /**
     Action - 1
     user click External Community on Settings Menu
  */ externalCommunitySelected: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "External Community Selected"
        });
    },
    /**
     Action - 3
     user click Lanjut after input the code community to activate
  */ activatedCodeSelected: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Selected",
            affiliate_code: code
        });
    },
    /**
     Action - 4
     user click Batal on pop-up Confirmation Code Community
  */ activatedCodeCanceled: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Canceled",
            affiliate_code: code
        });
    },
    /**
     Action - 5
     user click Konfirmasi on pop-up Confirmation Code Community
  */ activatedCodeConfirmed: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Confirmed",
            affiliate_code: code
        });
    },
    /**
     Action - 6
     user click Selesai on Success Activated Code Community page
  */ activatedCodeSuccessSelected: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Success Selected",
            affiliate_code: code
        });
    },
    /**
     Action - 7
     user click Keluar Komunitas on External Community Page
  */ exitCommunitySelected: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Exit Community Selected"
        });
    },
    /**
     Action - 8
     user click Batal on External Community Page
  */ exitCommunityCanceled: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Exit Community Canceled"
        });
    },
    /**
     Action - 9
     user click Keluar on External Community Page
  */ exitCommunityConfirmed: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Exit Community Confirmed"
        });
    }
};


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 63576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ PAGE_SOURCE_INDEX; },
/* harmony export */   "j4": function() { return /* binding */ mainProfileEvents; },
/* harmony export */   "nP": function() { return /* binding */ PAGE_SOURCE; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var PAGE_SOURCE;
(function(PAGE_SOURCE) {
    PAGE_SOURCE["streamPost"] = "Stream Post";
    PAGE_SOURCE["streamLikeList"] = "Stream Like List";
    PAGE_SOURCE["companyPage"] = "Company Page";
    PAGE_SOURCE["chat"] = "Chat";
    PAGE_SOURCE["search"] = "Search";
    PAGE_SOURCE["discoverPeople"] = "Discover People";
    PAGE_SOURCE["followers"] = "Followers";
    PAGE_SOURCE["following"] = "Following";
})(PAGE_SOURCE || (PAGE_SOURCE = {}));
var PAGE_SOURCE_INDEX = [
    "Stream Post",
    "Stream Like List",
    "Company Page",
    "Chat",
    "Search",
    "Discover People",
    "Followers",
    "Following",
    "My Profile",
    "Group Chat Bottom Sheet", 
];
var mainProfileEvents = {
    onViewProfile: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Stream View Profile", {
            "Page Source": pageSource
        });
    },
    onUserProfileViewed: function(pageSource) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Viewed", {
            "Page Source": pageSource
        });
    },
    onUserProfileChatSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Chat Selected");
    },
    onUserProfileFollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Follow Selected");
    },
    onUserProfileUnfollowSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unfollow Selected");
    },
    onUserProfileTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn On Alert");
    },
    onUserProfileComposePost: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Compose Post");
    },
    onUserProfileAddorRemovefromWatchlist: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist");
    },
    onUserProfileBlock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block");
    },
    onUserProfileSuccessfullyTurnOnAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn on alert");
    },
    onComposePostViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Compose Post Viewed");
    },
    onUserProfileAddOrRemoveFromWatchlistViewed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Add or Remove from Watchlist Viewed");
    },
    onUserProfileBlockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Block Confirmed");
    },
    onUserProfileSuccessfullyBlocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Blocked");
    },
    onUserProfileTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Turn Off Alert");
    },
    onUserProfileSuccessfullyTurnOffAlert: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Turn Off Alert");
    },
    onUserProfileUnblock: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock");
    },
    onUserProfileUnblockConfirmed: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Unblock Confirmed");
    },
    onUserProfileSuccessfullyUnblocked: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("User Profile Successfully Unblock");
    }
};


/***/ }),

/***/ 37842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39211);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79644);







var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function GreenVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Verified Account"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: URL_VERIFICATION_ARTICLE,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Pelajari Lebih Lanjut"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/widget-trending/icon-verified.svg",
            style: {
                width: "12px",
                marginLeft: 5
            },
            alt: "icon-verified"
        })
    });
}
function GreyVerifiedBadge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "12px",
            color: "#858585",
            padding: "6px 6px",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    as: "span",
                    family: "bold",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light,
                    size: "12px",
                    children: "Account Verified"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Identitas user telah terverifikasi sebagai nasabah Stockbit Sekuritas"
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            src: "/icon/verified-grey.svg",
            style: {
                width: "12px",
                marginLeft: 4
            },
            alt: "icon-verified"
        })
    });
}
function LabelVerifiedAccount(param) {
    var deprecatedVerifiedStatus = param.deprecatedVerifiedStatus, verifiedStatus = param.verifiedStatus;
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_COMMUNITY */ .P.VERIFIED_STATUS_COMMUNITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    if (verifiedStatus === lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_6__/* .VerifiedStatus.VERIFIED_STATUS_IDENTITY */ .P.VERIFIED_STATUS_IDENTITY) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreyVerifiedBadge, {});
    }
    if (deprecatedVerifiedStatus && verifiedStatus === undefined) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GreenVerifiedBadge, {});
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (LabelVerifiedAccount);


/***/ }),

/***/ 94493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SH": function() { return /* reexport */ Labels_LabelAdmin; },
  "QP": function() { return /* reexport */ Labels_LabelTopUser; },
  "uC": function() { return /* reexport */ LabelVerifiedAccount/* default */.Z; }
});

// UNUSED EXPORTS: LabelPro, LabelSuspended, LabelVerified

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var common_Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var common_Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var _style_color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/utils/userRole.js
var userRole = __webpack_require__(58080);
;// CONCATENATED MODULE: ./src/global/Labels/LabelAdmin.tsx





function LabelAdmin(param) {
    var privilege = param.privilege;
    if ((0,userRole/* getUserRole */.Rg)(privilege)) {
        return(// @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: (0,userRole/* getUserRole */.Rg)(privilege)
            })
        }));
    }
    return null;
}
/* harmony default export */ var Labels_LabelAdmin = (LabelAdmin);

;// CONCATENATED MODULE: ./src/global/Labels/LabelPro.tsx




function LabelPro() {
    return(// @ts-expect-error
    /*#__PURE__*/ _jsx(Button, {
        p: "0px",
        margin: "0 2px",
        round: true,
        children: /*#__PURE__*/ _jsx(Text, {
            size: "10px",
            color: color.suvaGrey,
            padding: "2px",
            children: "PRO"
        })
    }));
}
/* harmony default export */ var Labels_LabelPro = ((/* unused pure expression or super */ null && (LabelPro)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/global/Labels/LabelSuspended.tsx



var LabelSuspended_Tag = Tag/* default.Tag */.Z.Tag;
function LabelSuspended() {
    return /*#__PURE__*/ _jsx(LabelSuspended_Tag, {
        style: {
            borderColor: color.sunsetOrange,
            color: color.sunsetOrange,
            fontWeight: "bold"
        },
        children: "Suspended"
    });
}
/* harmony default export */ var Labels_LabelSuspended = ((/* unused pure expression or super */ null && (LabelSuspended)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var common_Tooltip = __webpack_require__(39211);
;// CONCATENATED MODULE: ./src/global/Labels/LabelTopUser.tsx





function LabelTopUser() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Tooltip/* default */.Z, {
        placement: "right",
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Stockbit top users"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button/* default */.Z, {
            p: "0px",
            margin: "0 2px",
            round: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "10px",
                color: _style_color/* default.suvaGrey */.Z.suvaGrey,
                padding: "2px",
                children: "TOP"
            })
        })
    });
}
/* harmony default export */ var Labels_LabelTopUser = (LabelTopUser);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var common_Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/Labels/LabelVerified.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/jsx-wrap-multilines */ 




var URL_VERIFICATION_ARTICLE = "https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/";
function LabelVerified() {
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: "rightTop",
        autoAdjustOverflow: true,
        overlayInnerStyle: {
            background: "rgba(64, 64, 64, 0.85)"
        },
        title: /*#__PURE__*/ _jsxs("p", {
            style: {
                marginBottom: 0
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    family: "bold",
                    color: color.light,
                    size: "12px",
                    style: {
                        lineHeight: "1.5"
                    },
                    children: "Verified Account"
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    color: color.light,
                    size: "12px",
                    height: "1.5",
                    children: [
                        "Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.",
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                color: color.primary,
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return window.open(URL_VERIFICATION_ARTICLE);
                            },
                            children: "Pelajari Lebih Lanjut"
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(IconWrapper, {
            padding: "0 4px",
            children: /*#__PURE__*/ _jsx(Iconmoon, {
                className: "icon-custom_verified-circle",
                size: "12px",
                color: color.primary
            })
        })
    });
}
/* harmony default export */ var Labels_LabelVerified = ((/* unused pure expression or super */ null && (LabelVerified)));

// EXTERNAL MODULE: ./src/global/Labels/LabelVerifiedAccount.tsx
var LabelVerifiedAccount = __webpack_require__(37842);
;// CONCATENATED MODULE: ./src/global/Labels/index.tsx








/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .ZP.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 58080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ isAllowedToBlockIp; },
/* harmony export */   "Rg": function() { return /* binding */ getUserRole; },
/* harmony export */   "_W": function() { return /* binding */ isAllowedToManageTop; },
/* harmony export */   "w1": function() { return /* binding */ isAllowedToSuspend; },
/* harmony export */   "xj": function() { return /* binding */ UserRoleName; }
/* harmony export */ });
/* unused harmony exports isAllowedToDelete, isAllowedToMultiDelete */
var UserRole = [
    "MEMBER",
    "ADMIN",
    "MODERATOR",
    "CONFIGURATOR",
    "SUPER_ADMIN", 
];
var UserRoleName = {
    MEMBER: "Member",
    ADMIN: "ADMIN",
    MODERATOR: "ADMIN",
    CONFIGURATOR: "CONFIGURATOR",
    SUPER_ADMIN: "ADMIN"
};
var checkPrivilege = function(userPriv, allowed) {
    return allowed.indexOf("".concat(userPriv)) >= 0;
};
var isAllowedToDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToMultiDelete = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToSuspend = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ]);
};
var isAllowedToBlockIp = function(userPriv) {
    return checkPrivilege(userPriv, [
        "4"
    ]);
};
var isAllowedToManageTop = function(userPriv) {
    return checkPrivilege(userPriv, [
        "1",
        "4"
    ]);
};
var getUserRole = function(userPriv) {
    if (!checkPrivilege(userPriv, [
        "1",
        "2",
        "4"
    ])) {
        return "";
    }
    var role = UserRole[userPriv];
    return UserRoleName[role];
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UserRole)));


/***/ })

}]);